import React, { useState } from 'react';
import Machines from './Machines';
import Consumables from './Consumables';
import SpareParts from './SpareParts';
import DemoUnit from './DemoUnit';
import Accessories from './Accessories';

const StockIn = ({ axiosInstance }) => {
  const [activeTab, setActiveTab] = useState('machines');

  const renderContent = () => {
    switch (activeTab) {
      case 'machines':
        return <Machines axiosInstance={axiosInstance} />;
      case 'consumables':
        return <Consumables axiosInstance={axiosInstance} />;
      case 'spare-parts':
        return <SpareParts axiosInstance={axiosInstance} />;
      case 'demo-unit':
        return <DemoUnit axiosInstance={axiosInstance} />;
      case 'accessories':
        return <Accessories axiosInstance={axiosInstance} />;
      default:
        return <Machines axiosInstance={axiosInstance} />;
    }
  };

  return (
    <div className="flex flex-col h-full">
      {/* Top Navigation Tabs */}
      <div className="bg-white border-b px-6 py-3 flex justify-center">
        <div className="flex space-x-1 bg-gray-100 p-1 rounded-lg">
          <button
            onClick={() => setActiveTab('machines')}
            className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
              activeTab === 'machines'
                ? 'bg-white text-gray-900 shadow-sm animate-beat'
                : 'text-gray-500 hover:text-gray-900 hover:bg-gray-200'
            }`}
          >
            Machines
          </button>
          <button
            onClick={() => setActiveTab('consumables')}
            className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
              activeTab === 'consumables'
                ? 'bg-white text-gray-900 shadow-sm animate-beat'
                : 'text-gray-500 hover:text-gray-900 hover:bg-gray-200'
            }`}
          >
            Consumables
          </button>
          <button
            onClick={() => setActiveTab('spare-parts')}
            className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
              activeTab === 'spare-parts'
                ? 'bg-white text-gray-900 shadow-sm animate-beat'
                : 'text-gray-500 hover:text-gray-900 hover:bg-gray-200'
            }`}
          >
            Spare Parts
          </button>
          <button
            onClick={() => setActiveTab('demo-unit')}
            className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
              activeTab === 'demo-unit'
                ? 'bg-white text-gray-900 shadow-sm animate-beat'
                : 'text-gray-500 hover:text-gray-900 hover:bg-gray-200'
            }`}
          >
            Demo Unit
          </button>
          <button
            onClick={() => setActiveTab('accessories')}
            className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
              activeTab === 'accessories'
                ? 'bg-white text-gray-900 shadow-sm animate-beat'
                : 'text-gray-500 hover:text-gray-900 hover:bg-gray-200'
            }`}
          >
            Accessories
          </button>
        </div>
      </div>

      {/* Main Content Area */}
      <div className="flex-1 overflow-auto bg-gray-50">
        <div
          key={activeTab}
          className="h-full animate-in fade-in zoom-in-95 duration-300"
        >
          {renderContent()}
        </div>
      </div>
    </div>
  );
};

export default StockIn;
